// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "e554f351bdb1b186247375f7acc4000c162842d3/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};